export const animals = [
  { char: '🐶', name: 'Dog', nameZh: '小狗', keywords: ['puppy', 'pet', '狗'] },
  { char: '🐱', name: 'Cat', nameZh: '小貓', keywords: ['kitten', 'meow', '貓'] },
  { char: '🐹', name: 'Hamster', nameZh: '倉鼠', keywords: ['pet', 'cute', '倉鼠'] },
  { char: '🐰', name: 'Rabbit', nameZh: '兔子', keywords: ['bunny', 'jump', '兔子'] },
  { char: '🦊', name: 'Fox', nameZh: '狐狸', keywords: ['wild', 'orange', '狐狸'] },
  { char: '🐻', name: 'Bear', nameZh: '熊', keywords: ['wild', 'honey', '熊'] },
  { char: '🐼', name: 'Panda', nameZh: '熊貓', keywords: ['china', 'bamboo', '熊貓'] },
  { char: '🐨', name: 'Koala', nameZh: '無尾熊', keywords: ['australia', 'sleep', '無尾熊'] },
  { char: '🐯', name: 'Tiger', nameZh: '老虎', keywords: ['cat', 'wild', '老虎'] },
  { char: '🦁', name: 'Lion', nameZh: '獅子', keywords: ['king', 'cat', '獅子'] },
  { char: '🐮', name: 'Cow Face', nameZh: '乳牛', keywords: ['moo', 'milk', '牛'] },
  { char: '🐷', name: 'Pig', nameZh: '豬', keywords: ['oink', 'pork', '豬'] },
  { char: '🐸', name: 'Frog', nameZh: '青蛙', keywords: ['green', 'jump', '青蛙'] },
  { char: '🐵', name: 'Monkey', nameZh: '猴子', keywords: ['banana', 'silly', '猴子'] },
  { char: '🐧', name: 'Penguin', nameZh: '企鵝', keywords: ['cold', 'bird', '企鵝'] },
  { char: '🐦', name: 'Bird', nameZh: '鳥', keywords: ['fly', 'tweet', '鳥'] },
  { char: '🐤', name: 'Chick', nameZh: '小雞', keywords: ['baby', 'yellow', '小雞'] },
  { char: '🦉', name: 'Owl', nameZh: '貓頭鷹', keywords: ['bird', 'night', '貓頭鷹'] },
  { char: '🦄', name: 'Unicorn', nameZh: '獨角獸', keywords: ['magic', 'fantasy', '獨角獸'] },
  { char: '🦋', name: 'Butterfly', nameZh: '蝴蝶', keywords: ['pretty', 'fly', '蝴蝶'] },
  { char: '🐙', name: 'Octopus', nameZh: '章魚', keywords: ['sea', 'ocean', '章魚'] },
  { char: '🐠', name: 'Tropical Fish', nameZh: '熱帶魚', keywords: ['sea', 'nemo', '熱帶魚'] },
  { char: '🐬', name: 'Dolphin', nameZh: '海豚', keywords: ['sea', 'smart', '海豚'] },
  { char: '🐳', name: 'Whale', nameZh: '鯨魚', keywords: ['sea', 'big', '鯨魚'] },
  { char: '🦖', name: 'T-Rex', nameZh: '暴龍', keywords: ['dino', 'jurassic', '暴龍'] },
];